import { Observable } from 'rxjs'
import { map, pluck } from 'rxjs/operators'

import { Manifestation } from '@skinsoft/types'
import { OfflineDataFetcher } from '@skinsoft/offline'

export class ManifestationOfflineDataFetcher extends OfflineDataFetcher<Manifestation>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    /*public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.manifestation) {
            return entity.manifestation.id === id;
        }
        return false;
    }

}